<template>
  <div v-if="user.id">
    <ClientBusinessIndex />
  </div>
</template>

<script>
import ClientBusinessIndex from '@/components/hr/client-business-index.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    ClientBusinessIndex
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>

